<template>
  <div>

    <c-title>Was möchten Sie tun?</c-title>

    <p>Bitte starten Sie den Bewerbungsprozess nur für das Förderprogramm, für das Sie sich tatsächlich bewerben möchten.
    </p>
    <p>Weitere Informationen zu den Förderprogrammen erhalten Sie auf der <a
      href="https://claussen-simon-stiftung.de"
      rel="noopener"
      target="_blank"
    >Website der Claussen-Simon-Stiftung</a>.</p>

    <c-form @submit.prevent="submit">

      <c-form-fieldset legend="Anderes">
        <c-form-list id="other-list">
          <c-form-list-item>
            <c-form-radio
              id="other-alumni"
              v-model="selection"
              :value="{ 'role': 'applicant,student,pupil', 'selection': 'other-alumni' }"
              label="Ich bin aktive/-r oder ehemalige/-r Geförderte/-r der Claussen-Simon-Stiftung."
              name="selection"
            />
          </c-form-list-item>
        </c-form-list>
      </c-form-fieldset>

      <!--
      <c-form-fieldset legend="Claussen-Simon-Wettbewerb für...">
        <c-form-list id="program-list">

          <c-form-list-item>
            <c-form-radio
              id="unseren-schulen"
              :value="{
                role: 'pupil',
                selection: 'unseren-schulen'
              }"
              v-model="selection"
              label="Schulen"
              name="selection"
            />
          </c-form-list-item>

          <c-form-list-item>
            <c-form-radio
              id="unseren-hochschulen"
              :value="{
                role: 'student',
                selection: 'unseren-hochschulen'
              }"
              v-model="selection"
              label="Hochschulen"
              name="selection"
            />
          </c-form-list-item>

        </c-form-list>
      </c-form-fieldset>
      -->

      <c-form-fieldset legend="Bewerbung für ein Förderprogramm">
        <c-busy v-if="loadStatus === $config.status.LOADING" />

        <c-form-list
          v-else-if="loadStatus !== $config.status.LOADING &&
          workflows.length"
          id="workflow-list"
        >
          <c-form-list-item
            v-for="workflow in workflows"
            :key="workflow.identifier"
          >
            <c-form-radio
              :id="workflow.name"
              :label="workflow.title"
              :value="workflow.name"
              v-model="selection"
              name="selection"
            />
            <p
              v-if="workflow.subtitle"
              class="form-checkbox-radio__subtitle"
            >
              <i>{{ workflow.subtitle }}</i>
            </p>
          </c-form-list-item>

        </c-form-list>

        <p v-if="!workflows.length">
          Zurzeit sind keine Bewerbungen möglich.
          Über die Bewerbungs- und Teilnahmefristen der einzelnen Förderprogramme und Wettbewerbe können
          Sie sich bei uns auf der Website informieren:
          www.claussen-simon-stiftung.de [verlinken/in neuem Fenster öffnen]
        </p>
      </c-form-fieldset>

      <c-button :busy="saveStatus === $config.status.SAVING">
        Weiter
      </c-button>

    </c-form>

  </div>
</template>

<script>
import CButton from '@/components/CButton'
import CForm from '@/components/form/CForm'
import CFormFieldset from '@/components/form/CFormFieldset'
import CFormList from '@/components/form/CFormList'
import CFormListItem from '@/components/form/CFormListItem'
import CFormRadio from '@/components/form/CFormRadio'
import CTitle from '@/components/CTitle'
import CBusy from '@/components/CBusy'

import handleRequestError from '@/functions/handleRequestError'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'VSelect',

  components: {
    CButton,
    CForm,
    CFormFieldset,
    CFormList,
    CFormListItem,
    CFormRadio,
    CTitle,
    CBusy
  },

  data () {
    return {
      saveStatus: this.$config.status.IDLE,
      loadStatus: this.$config.status.IDLE,
      selection: '',
      workflows: []
    }
  },

  validations: {
    selection: {
      required
    }
  },

  created () {
    this.loadStatus = this.$config.status.LOADING
    this.$api.get('workflow/workflow/')
      .then(response => {
        this.workflows = response.data
        this.loadStatus = this.$config.status.SUCCESS
      })
      .catch(error => {
        handleRequestError({
          error,
          fallback: 'Die Förderprogramme konnten nicht geladen werden. Bitte versuchen sie es später erneut.'
        })

        this.loadStatus = this.$config.status.ERROR
      })
  },

  methods: {

    submit () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$store.commit('notifications/add', {
          text: 'Bitte wählen Sie eine Möglichkeit.',
          type: 'error'
        })

        return
      }

      this.saveStatus = this.$config.status.SAVING

      if (typeof this.selection === 'string') {
        this.$api.post('workflow/process/start/', { workflow: this.selection })
          .then(response => {
            if (response.status === 200) {
              this.$store.commit('notifications/add', {
                type: 'success',
                text: 'Der Bewerbungsprozess wurde gestartet.'
              })
              return this.$api.get('auth/user/')
            } else {
              this.saveStatus = this.$config.status.ERROR
              this.$store.commit('notifications/add', {
                type: 'error',
                text: 'Der Bewerbungsprozess konnte nicht gestartet werden.'
              })
            }
          })
          .then(response => {
            this.$store.commit('user/data', response.data)
            this.$router.push({ name: 'dashboard-personal-data' })
          })
          .catch(error => {
            this.saveStatus = this.$config.status.ERROR
            let msg = 'Bitte versuchen Sie es später erneut.'
            if (error.response.data.hasOwnProperty('code')) {
              switch (error.response.data.code) {
                case '1537779427':
                  msg = 'Sie haben bereits eine laufende Bewerbung auf dieses Förderprogramm.'
                  break
              }
            }
            error.message = msg
            handleRequestError({
              error,
              fallback: 'Der Bewerbungsprozess konnte leider nicht gestartet werden. ' + msg
            })
          })
      } else {
        this.$api.post('user/groups/', this.selection)
          .then(response => {
            this.$store.commit('notifications/add', {
              type: 'success',
              text: 'Ihr Profil wurde angepasst.'
            })
            return this.$api.get('auth/user/')
              .then(response => {
                this.$store.commit('user/data', response.data)
                this.$router.push({ name: 'dashboard' })
              })
              .catch(error => {
                handleRequestError({
                  error,
                  fallback: 'Ihre Auswahl konnte leider nicht gespeichert werden. Bitte versuchen Sie es später erneut.'
                })
              })
          })
      }
    }
  }
}
</script>

<style scoped>
.form-checkbox-radio__subtitle {
  padding-left: 28px;
}
</style>
